var Legacy = Legacy || {};

(function (Legacy, $) {
  Legacy.NameField = { fields: {} };

  Legacy.NameField.getOpenFields = function () {
    var openFields = [];
    for (var fieldId in Legacy.NameField.fields) {
      var field = Legacy.NameField.fields[fieldId];
      if (field.isOpen())
        openFields.push(field);
    }
    return openFields;
  };

  function keepFlyoutInWindow($flyout) {
    $flyout.css('left', '');
    var flyoutLeft = $flyout.offset().left;
    var flyoutRight = flyoutLeft + $flyout.outerWidth();
    if (flyoutRight > $(window).width())
      $flyout.css('left', $flyout.position().left - (flyoutRight - $(window).width()));
  }

  $.fn.nameField = function () {
    $(this).each(function () {
      var $fieldContainer = $(this);

      if ($fieldContainer.data('rustig.namefield.isloaded'))
        return;

      var $mainInput = $('.name-full-input', $fieldContainer);
      $fieldContainer.copyFieldBooleanAttributes($mainInput);
      $mainInput.data('rustig.namefield.isloaded', true);

      var $flyoutButton = $('.name-dropdown-button', $fieldContainer);
      var $flyout = $('.name-flyout', $fieldContainer);
      var $prefix = function () {
        return $('.prefix', $fieldContainer);
      };

      var $first = $('.first', $fieldContainer);
      var $middle = $('.middle', $fieldContainer);
      var $last = $('.last', $fieldContainer);
      var $suffix = function () {
        return $('.suffix', $fieldContainer);
      };

      var sizeFlyoutToInput = function () {
        $flyout.outerWidth($mainInput.outerWidth());
      };

      $flyoutButton.on('click.rustig.name-field', function (e) {
        if ($mainInput.isReadonly() || $mainInput.isDisabled())
          return false;

        if ($flyout.is(':visible'))
          $flyout.hide();
        else {
          $('.flyout').hide();
          sizeFlyoutToInput();
          $flyout.show();
          keepFlyoutInWindow($flyout);
        }
        
        return false;
      });

      $flyout.hide()
        .focus(function () { $flyout.show() }); // open flyout if any field in the flyout gets focus

      var notLastClickedInDropDownFlyout = function (e) {
        var $target = e ? $(e.target) : $lastClicked;
        if (!$target) return true;
        return $target.closest('.dropdown-flyout').length == 0;
      }

      var documentClicked = function (e) {
        if ($(e.target).parents().index($fieldContainer) == -1 && notLastClickedInDropDownFlyout(e))
          $flyout.hide();
      };
      $(document).on('click.rustig.name-field', documentClicked);

      var $lastClicked;
      var documentMouseDown = function (e) {
        $lastClicked = $(e.target);
      };
      $(document).on('mousedown.rustig.name-field', documentMouseDown);

      var notLastClickedInFlyout = function () {
        if (!$lastClicked) return true;
        return $lastClicked.closest('.name-flyout').length == 0;
      }

      var notLastClickedFlyoutButton = function () {
        if (!$lastClicked) return true;
        return $lastClicked.closest('.name-flyout-button').length == 0;
      }

      $fieldContainer.on('blur.rustig.name-field', '.name-flyout input, .name-flyout a', function (e) {
        if (notLastClickedInFlyout() && notLastClickedFlyoutButton() && notLastClickedInDropDownFlyout()) {
          setTimeout(function () {
            if ($('.name-flyout :focus', $fieldContainer).length == 0)
              $flyout.hide();
          }, 100);
        }
        $lastClicked = null;
      });

      var suppressChanges = false;
      $mainInput.on('change.rustig.name-field', function () {
        if (suppressChanges) return;
        suppressChanges = true;

        var name = Rustig.PersonName.parse($(this).val());
        $mainInput.val(name.format()).change();
        $prefix().val(name.prefix).change();
        $first.val(name.first).change();
        $middle.val(name.middle).change();
        $last.val(name.last).change();
        $suffix().val(name.suffix).change();

        suppressChanges = false;
      });

      $mainInput[0].refreshFormattedName = function (formattedName) {
        $mainInput.val(formattedName);
      };

      var updateInputs = function () {
        suppressChanges = true;
        
        var name = new Rustig.PersonName($prefix().val(), $first.val(), $middle.val(), $last.val(), $suffix().val());

        $mainInput.val(name.format()).change();

        suppressChanges = false;
      }

      $fieldContainer[0].asAtomicChange = function (action) {
        suppressChanges = true;
        action();
        suppressChanges = false;
        updateInputs();
      }

      $fieldContainer.on('change.rustig.name-field', '.prefix, .first, .middle, .last, .suffix', function () {
        if (suppressChanges) return;
        updateInputs();
      });

      updateInputs();

      var fieldObject = {
        getValue: function () {
          return $mainInput.val();
        },
        setValue: function (value) {
          $mainInput.val(value).change();
        },
        enable: function (enable) {
          if (typeof enable == "undefined" || enable)
            $fieldContainer.enableChildren();
          else
            $fieldContainer.disableChildren();
        },
        disable: function () {
          $fieldContainer.disableChildren();
        },
        focus: function () {
          $mainInput.focus();
        },
        close: function () {
          $flyout.hide();
        },
        isOpen: function () {
          return $flyout.is(':visible');
        },
        resizeFlyout: function () {
          sizeFlyoutToInput();
        }
      };
      var mainId = $mainInput.attr('id');
      if (!mainId) {
        $mainInput.uniqueId();
        mainId = $mainInput.attr('id');
      }
      Legacy.NameField.fields[mainId] = fieldObject;

      function dispose() {
        $(document)
          .off('click', documentClicked)
          .off('mousedown', documentMouseDown);
        delete Legacy.NameField.fields[mainId];
      }

      $mainInput.on('remove', function () {
        dispose();
      });
    });
  };

  $(window).resize(function () {
    var openFields = Legacy.NameField.getOpenFields();
    openFields.forEach(function (field) {
      field.resizeFlyout();
    });
  });
})(Legacy = Legacy || {}, jQuery);
